// Typed access to the API base URL. Empty string means "same origin".
export const API_BASE = (import.meta.env.VITE_API_BASE as string) || "";
